import { render, staticRenderFns } from "./ComicsInfo.vue?vue&type=template&id=7dbb82e5&scoped=true"
import script from "./ComicsInfo.vue?vue&type=script&lang=js"
export * from "./ComicsInfo.vue?vue&type=script&lang=js"
import style0 from "./ComicsInfo.vue?vue&type=style&index=0&id=7dbb82e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbb82e5",
  null
  
)

export default component.exports